import { render, staticRenderFns } from "./TypeFilters.vue?vue&type=template&id=1dcc1cd2&scoped=true"
import script from "./TypeFilters.vue?vue&type=script&lang=ts"
export * from "./TypeFilters.vue?vue&type=script&lang=ts"
import style0 from "./TypeFilters.vue?vue&type=style&index=0&id=1dcc1cd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc1cd2",
  null
  
)

export default component.exports